module.exports = __webpack_public_path__ + "static/media/model-mission-12.e40d8afc.png";